import React from 'react'
import '../../styles/flash-media.sass'
import file from '../../img/File icon.svg'
import { useHistory } from 'react-router-dom'
import { files } from '../files'

const FlashMediaComponent = () => {
  const history = useHistory()

  return (
    <div className='flash-media'>
      <p className='title'>Описание</p>
      Программное обеспечение «FlashMedia» предназначено для предоставления услуг по размещению рекламного контента пользователя и его доставке до конечного потребителя через медиаустройства.
      <p className='title'>Функции</p>
      Программное обеспечение «FlashMedia» обеспечивает двухстороннее взаимодействие пользователя с программой и выполнение следующих задач:
      <br/>1)	формирование заказов на показ рекламного контента;
      <br/>2)	модерация заказов на показ рекламного контента;
      <br/>3)	оплата заказа на показ рекламного контента;
      <br/>4)	управление тарифами показа рекламного контента;
      <br/>5)	управление площадками показа рекламного контента;
      <br/>6)	управление плейлистами площадок показа рекламного контента;
      <br/>7)	отображение состояния устройств воспроизведения рекламного контента;
      <br/>8)	управление пользователями и обеспечение разграничения прав доступа к функционалу программы.
      <p className='title'>Системные стребования</p>
      <div className='table'>
        <table>
          <tr>
            <th><div>Компонент</div></th>
            <th><div>Параметр</div></th>
          </tr>
          <tr><td><div>Процессор</div></td><td><div>Intel с тактовой частотой 3.6 ГГц или более</div></td></tr>
          <tr><td><div>Оперативная память</div></td><td><div>8 Гб SDRAM или более</div></td></tr>
          <tr><td><div>Жесткий диск</div></td><td><div>120 Гб SSD или более</div></td></tr>
          <tr><td><div>Видеоадаптер</div></td><td><div>Встроен в системную плату</div></td></tr>
          <tr><td><div>Сетевая плата</div></td><td><div>Ethernet не менее 100 Мбит/сек</div></td></tr>
          <tr><td><div>Дополнительное оборудование</div></td><td><div>Монитор SVGA 1920х1080, мышь, клавиатура</div></td></tr>
          <tr><td><div>Доступ к сети Интернет</div></td><td><div>Постоянный доступ к сети не ниже 100 Mbps</div></td></tr>
        </table>
      </div>
      <p className='title'>Документация и файлы</p>
      <div className='files' onClick={() => {
        window.open(`${files.install}`, '_blank')
      }}>
        <img src={file} alt='file-icon' /><p>Инструкция по установке</p>
      </div>
      <div className='files' onClick={() => {
        window.open(`${files.manual}`, '_blank')
      }}>
        <img src={file} alt='file-icon' /><p>Инструкция по эксплуатации</p>
      </div>
      <div className='files' onClick={() => {
        window.open(`${files.functional}`, '_blank')
      }}>
        <img src={file} alt='file-icon' /><p>Описание функциональных характеристик</p>
      </div>
      <div className='files' onClick={() => {
        window.open(`${files.processes}`, '_blank')
      }}>
        <img src={file} alt='file-icon' /><p>Процессы жизненного цикла</p>
      </div>
      {/* <a className='files' href={`${files.prFiles}`} download>
        <img src={file} alt='file-icon' /><p>Файлы программы</p>
      </a> */}
      <p className='title'>Стоимость</p>
      Расчет стоимости программного обеспечения осуществляется индивидуально. Оставьте заявку и наш менеджер свяжется с Вами.
      <br/>
      <br/>
      <div className='button button__default'>
        <button onClick={() => {
          history.push('/feedback')
        }}>Запросить стоимость</button>
        <div className='background'></div>
      </div>
    </div>
  )
}

export default FlashMediaComponent